import * as o from "react";
import s from "../lib/IconBase.es.js";
import a from "../defs/List.es.js";
const t = o.forwardRef((e, r) => /* @__PURE__ */ o.createElement(s, { ref: r, ...e, weights: a }));
t.displayName = "ListIcon";
const c = t;
export {
  c as List,
  t as ListIcon
};
